<template>
  <div class="grade-list" v-bitmap="gradeListGetResult">
    <!-- 未确认创建的年级 -->
    <gradeItem
      v-for="(item, index) in notCreatedgrades"
      :key="index + Math.random() * 10"
      :createdState="'notCreated'"
      :grade="item"
      @gradeNameInput="gradeNameInput($event, item)"
      @gradeCodeInput="gradeCodeInput($event, item)"
      @gradeConfirmEdit="gradeConfirmEdit($event, item)"
      @gradeEdit="item.isEdit = true"
      @gradeDelete="gradeDelete($event, index)"
    />
    <!-- 已确认创建的年级 -->
    <gradeItem
      v-for="(item, index) in createdgrades"
      :key="index + Math.random() * 10"
      :createdState="'created'"
      :grade="item"
      @gradeNameInput="gradeNameInput($event, item)"
      @gradeCodeInput="gradeCodeInput($event, item)"
      @gradeConfirmEdit="gradeConfirmEdit($event, item)"
      @gradeEdit="item.isEdit = true"
      @gradeDelete="gradeDelete($event, index)"
      @createdClassSuccessCallBack="createdClassSuccessCallBack($event, item)"
      @deleteClassCallBack="deleteClassCallBack($event, item)"
      v-loading="item.gradeId == gradeItemLoadingById"
      @showEditClassDialog="showEditClassDialog($event, item)"
    />
    <el-dialog
      destroy-on-close
      :title="
        !isShowEditTeacherBindingRelationship
          ? '班级设置'
          : `编辑${this.currentClassItem.className}与教师的绑定关系`
      "
      :width="isShowEditTeacherBindingRelationship ? '90%' : '20%'"
      :visible.sync="isSelectSetItemDialogShow"
      @closed="Close"
    >
      <div class="select-dialog-inner" v-if="!isShowEditTeacherBindingRelationship">
        <button
          class="select-button class-info"
          @click="clickEditClassInfo"
          v-hasPermi="'sc:class:edit'"
        >
          编辑班级信息
        </button>
        <button
          class="select-button edit-teacher"
          @click="clickEditTeacherList"
          v-hasPermi="'sc:classteacher:list'"
        >
          编辑教师列表
        </button>
      </div>
      <teacherList
        :currentClassItem="currentClassItem"
        :currentGradeItem="currentGradeItem"
        v-else
      />
    </el-dialog>
  </div>
</template>

<script>
import teacherList from "../grademanagement-teacherlist/grademanagement-teacherlist";
import gradeItem from "../grademanagement-gradeitem/gradeManagement-gradeItem";
export default {
  components: {
    gradeItem,
    teacherList,
  },
  watch: {
    createdgrades: {
      handler(val) {
        let classNumber = 0;
        val.forEach((item) => {
          classNumber += item.schoolClassList.length;
        });
        this.$eventBus.$emit("updategradeClassNumber", {
          gradeCode: val.length,
          classNumber,
        });
      },
      immediate: true,
      deep: true,
    },
    //只有未创建列表不为空才显示确认创建按钮
    notCreatedgrades(val) {
      if (val.length != 0 || this.createdgrades.length != 0) {
        this.gradeListGetResult = "success";
      } else {
        this.gradeListGetResult = "nullData";
      }

      if (val.length == 0) {
        this.$eventBus.$emit("setConfirmCreatedButtonShow", false);
      } else {
        this.$eventBus.$emit("setConfirmCreatedButtonShow", true);
      }
    },
  },
  created() {
    this.getgradeList();
    this.$eventBus.$off("setNotCreatedgradeList");
    this.$eventBus.$on("setNotCreatedgradeList", (gradeList) => {
      if (!gradeList[0]) {
        this.notCreatedgrades = [];
      } else if (gradeList[0] && gradeList[0].createdMode == "fast") {
        this.notCreatedgrades = this.notCreatedgrades.filter((item) => {
          return item.createdMode != "fast";
        });
        this.notCreatedgrades.push(...gradeList);
      } else {
        this.notCreatedgrades.unshift(...gradeList);
      }
    });
    this.$eventBus.$off("confirmCreated");
    this.$eventBus.$on("confirmCreated", (res) => {
      for (let item of this.notCreatedgrades) {
        if (item.isEdit) {
          return this.$message.warning("请先确认修改年级信息！");
        } else if (!this.filterRepeatgrade(item)) {
          item.isEdit = true;
          return this.$message.warning("存在重复名称或编号的年级，请先将其修改");
        }
      }
      this.addGrades();
    });
  },
  data() {
    return {
      gradeListLoading: false,
      gradeItemLoadingById: -1,
      createdgrades: [],
      notCreatedgrades: [],
      gradeListGetResult: "nullData",
      isSelectSetItemDialogShow: false,
      currentClassItem: null,
      currentGradeItem: null,
      isShowEditTeacherBindingRelationship: false,
    };
  },
  methods: {
    Close() {
      this.isShowEditTeacherBindingRelationship = false;
    },
    showEditClassDialog(classItem, gradeItem) {
      this.currentClassItem = classItem;
      this.currentGradeItem = gradeItem;
      this.isSelectSetItemDialogShow = true;
    },
    clickEditTeacherList() {
      this.isShowEditTeacherBindingRelationship = true;
    },
    clickEditClassInfo() {
      this.isSelectSetItemDialogShow = false;
      Vue.set(this.currentClassItem, "classIsEdit", true);
    },
    getgradeList() {
      // this.gradeListGetResult = "loading";
      this.get(this.$url.getgradeList, {
        schoolId: this.school.id,
      })
        .then((res) => {
          if (res.code != 200) {
            this.gradeListGetResult = "error";
            return this.$message.error(res.msg);
          }
          this.createdgrades = [];
          const gladeList = res.data;
          gladeList.length > 0
            ? (this.gradeListGetResult = "success")
            : (this.gradeListGetResult = "nullData");
          gladeList.forEach((item) => {
            item.isEdit = false;
            for (let classItem of item.schoolClassList) {
              classItem.classIsEdit = false;
            }
          });
          this.createdgrades.push(...gladeList);
        })
        .catch((err) => {
          this.gradeListGetResult = "error";
          // this.$message.error("获取年级列表失败，请稍后再试");
        });
    },
    gradeNameInput(val, item) {
      Vue.set(item, "gradeName", val);
    },
    gradeCodeInput(val, item) {
      Vue.set(item, "gradeCode", val);
    },
    gradeConfirmEdit({ createdState, gradeId }, gradeItem) {
      if (!this.filterRepeatgrade(gradeItem)) {
        return this.$message.warning("年级名字与年级编号不能重复！");
      } else {
        if (createdState == "notCreated") {
          Vue.set(gradeItem, "isEdit", false);
        } else if (createdState == "created") {
          this.gradeItemLoadingById = gradeItem.gradeId;
          //调用接口,根据ID修改年级名字与编号
          this.put(this.$url.editGradeInfoById, {
            id: gradeId,
            updateBy: this.user.id,
            gradeName: gradeItem.gradeName,
            gradeCode: gradeItem.gradeCode,
          })
            .then((res) => {
              this.gradeItemLoadingById = -1;
              if (res.code != 200) {
                return this.$message.error("修改失败！");
              }
              this.$message.success("修改成功");
              Vue.set(gradeItem, "isEdit", false);
            })
            .catch((err) => {
              this.gradeItemLoadingById = -1;
              this.$message.error("修改失败！");
            });
        }
      }
    },
    gradeDelete({ createdState, gradeId, gradeName }, gradeIndex) {
      if (createdState == "notCreated") {
        this.notCreatedgrades.splice(gradeIndex, 1);
      } else if (createdState == "created") {
        this.$confirm(`是否删除${gradeName}?`, "删除年级确认", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.delete(`${this.$url.deleteGradeById}/${gradeId}`)
              .then((res) => {
                if (res.code == 500) {
                  return this.$message.error("该年级下存在班级，不能删除");
                } else if (res.code != 200) {
                  return this.$message.error("删除失败！");
                }
                this.createdgrades.splice(gradeIndex, 1);
                this.$message.success("删除成功");
              })
              .catch((err) => {
                this.$message.error("删除失败,请稍后再试");
              });
          })
          .catch(() => {});
      }
    },
    addGrades() {
      let waitCreatedGradeList = [];
      for (let item of this.notCreatedgrades) {
        let gradeTemplate = {};
        let { gradeCode, gradeName } = item;
        gradeTemplate.createBy = this.user.id;
        gradeTemplate.schoolId = this.school.id;
        gradeTemplate.schoolName = this.school.schoolName;
        gradeTemplate.gradeCode = gradeCode;
        gradeTemplate.gradeName = gradeName;
        waitCreatedGradeList.push(gradeTemplate);
      }
      this.post(this.$url.addGrades, waitCreatedGradeList)
        .then((res) => {
          if (res.code != 200) {
            return this.$message.error("创建失败，请稍后再试。");
          }
          this.$message.success("创建成功");
          this.getgradeList();
          this.notCreatedgrades = [];
          this.$eventBus.$emit("confirmCreatedCallBack");
        })
        .catch((err) => {
          this.$message.error("创建失败，请稍后再试。");
        });
    },
    createdClassSuccessCallBack(classList, gradeItem) {
      Vue.set(gradeItem, "schoolClassList", classList);
    },
    deleteClassCallBack(classIndex, gradeItem) {
      gradeItem.schoolClassList.splice(classIndex, 1);
    },
    filterRepeatgrade(gradeItem) {
      let allgradeList = [];
      allgradeList = [...this.createdgrades, ...this.notCreatedgrades];
      let repeatgradeList = [];
      allgradeList.forEach((item) => {
        if (
          item.gradeName == gradeItem.gradeName ||
          item.gradeCode == gradeItem.gradeCode
        ) {
          repeatgradeList.push(item);
        }
      });
      if (repeatgradeList.length > 1) {
        return false;
      } else {
        return true;
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "./gradeManagement-gradeList.scss";
</style>
